<template>
  <v-app>
    <v-container
      fluid
      tag="section"
      class="pt-0 px-6"
    >
      <v-row justify="center">
        <v-col
          cols="12 px-6"
          sm="10"
          md="8"
        >
          <v-row>
            <v-col
              class="py-0  d-flex justify-center"
              offset-sm="4"
              sm="4"
            >
              <v-img
                contain
                height="80pt"
                width="100pt"
                :src="'data:image/jpg;base64,'+configuration.interface_description.first_screen.logo_base64"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-center pb-1">
              <span :style="`color: ${configuration.interface_description.first_screen.text1.color};font-size: ${configuration.interface_description.first_screen.text1.size}px`">
                {{ configuration.interface_description.first_screen.text1.text }}
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-center py-1">
              <span :style="`color: ${configuration.interface_description.first_screen.text2.color}; font-size: ${configuration.interface_description.first_screen.text2.size}px`">
                {{ this.configuration.interface_description.first_screen.text2.text }}
              </span>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              class="payment-text d-flex align-center pb-0"
              cols="12"
            >
              <span>К оплате:</span>
            </v-col>
            <v-col class="payment-text2 py-0">
              {{ Number(order.sumFull).money() }}
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              class="py-1 payment-text"
            >
              Реквизиты платежа
            </v-col>
            <v-col
              v-if="!noOrder"
              class="payment-text3 py-1"
            >
              Заказ № {{ this.order.number }}
            </v-col>
          </v-row>
          <v-row v-if="!noOrder">
            <v-col class="py-1">
              <span class="payment-text3">Назначение платежа:</span><span class="payment-text4"> {{ this.order.dest }}</span>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              v-if="noOrder"
              class="text-start pa-1 payment-no-order"
            >
              Заказов не обнаружено
            </v-col>
          </v-row>
          <v-row>
            <v-col class="payment-text pb-1">
              Способы оплаты
            </v-col>
          </v-row>
          <v-row>
            <v-col
              class="py-1"
            >
              <v-input
                v-ripple
                :loading="loading || noOrder"
                :disabled="loading || noOrder"
                hide-details
                :class="`${(loading || noOrder) ? 'payment-pay-disabled' : 'payment-pay'} d-flex py-1 pr-1 pl-4 align-center`"
                @click="onStart"
              >
                <div class="d-flex align-self-center justify-start">
                  <v-img
                    contain
                    height="30px"
                    width="60px"
                    src="/images/sbp_logo_3.png"
                    alt=""
                  />
                </div>
                <div class="d-flex justify-center flex-grow-1 align-center ">
                  Оплатить
                </div>
              </v-input>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row
        v-if="!noOrder"
        v-resize="onResizeWindow"
      >
        <v-col>
          <v-footer
            :fixed="footerFixed"
            color="white"
          >
            <v-row>
              <v-col
                cols="12"
                class="payment-text text-center py-0"
              >
                Оплачивая Вы соглашаетесь с
              </v-col>
              <v-col class="payment-text text-center py-0">
                условием оферты
              </v-col>
            </v-row>
          </v-footer>
        </v-col>
      </v-row>
      <v-dialog
        v-model="dialogVisible"
        fullscreen
      >
        <v-card>
          <v-toolbar flat>
            <v-btn
              icon
              @click="dialogVisible=false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Реквизиты платежа</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col>
                <v-text-field
                  class="dialog-input"
                  dense
                  readonly
                  color="white"
                  label="Получатель"
                  :value="order.recipientName"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  class="dialog-input"
                  readonly
                  dense
                  label="ИНН"
                  :value="order.recipientInn"
                />
              </v-col>
              <v-col>
                <v-text-field
                  class="dialog-input"
                  readonly
                  dense
                  label="КПП"
                  :value="order.recipientKpp"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  class="dialog-input"
                  readonly
                  dense
                  label="Расчётный счёт"
                  :value="order.recipientRs"
                />
              </v-col>
              <v-col>
                <v-text-field
                  class="dialog-input"
                  readonly
                  dense
                  label="БИК"
                  :value="order.bankBic"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  class="dialog-input"
                  readonly
                  dense
                  label="Банк получателя"
                  :value="order.bankName"
                />
              </v-col>
              <v-col>
                <v-text-field
                  class="dialog-input"
                  readonly
                  dense
                  label="К/С"
                  :value="order.bankKs"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  class="dialog-input"
                  readonly
                  dense
                  label="КБК"
                  :value="order.kbk"
                />
              </v-col>
              <v-col>
                <v-text-field
                  class="dialog-input"
                  readonly
                  dense
                  label="ОКТМО"
                  :value="order.oktmo"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  readonly
                  class="dialog-input"
                  dense
                  label="Плательщик"
                  :value="order.payerFio"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea
                  readonly
                  class="dialog-input"
                  dense
                  label="Адрес"
                  rows="2"
                  auto-grow
                  :value="order.payerAddress"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  readonly
                  class="dialog-input"
                  dense
                  label="Телефон"
                  :value="order.payerPhone"
                />
              </v-col>
              <v-col>
                <v-text-field
                  readonly
                  class="dialog-input"
                  dense
                  label="Эл. почта"
                  :value="order.payerEmail"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  class="dialog-input"
                  readonly
                  dense
                  label="Назначение"
                  :value="order.dest"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  readonly
                  class="dialog-input-sum"
                  dense
                  label="К оплате"
                  :value="Number(order.sumFull).money()"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </v-app>
</template>
<script>
import {
  JustpayQrPaymentService,
  PaygineOrderStateEnum
} from "@/views/loyalty/shared/services/justpay-qrpayment-service"
import { guid, isBlank } from "@/views/loyalty/shared/modules/utilities"
import { JustpayOrderModel, OrderStateEnum } from "@/views/loyalty/models/justpay-order.model"
import { JustpayPaymentSystemService } from "@/views/loyalty/shared/services/justpay-paymentsystem-service"

export default {
  name: 'QrPayment',
  data: () => ({
    configuration: {},
    dialogVisible: false,
    footerFixed: true,
    guid: null,
    justpayQrPaymentService: null,
    loading: false,
    nomenclatures: [],
    noOrder: false,
    order: new JustpayOrderModel(),
    orderId: null,
    sbpId: null,
    paygineTimeout: 0,
    paymentService: null,
    pointId: null
  }),
  async beforeMount () {
    this.pointId = this.$route.query.id
    localStorage.setItem('pointId', this.pointId)
    // console.log('point.id', this.pointId)
    this.paymentService = new JustpayPaymentSystemService()
    this.justpayQrPaymentService = new JustpayQrPaymentService()
    const order = await this.justpayQrPaymentService.getOrder(this.pointId)
    if (!order) {
      this.noOrder = true
    }
    // console.log('const order', order)
    this.order = new JustpayOrderModel(order)
    // console.log('this.order', this.order)
    if (this.order.sumFull === 0) {
      this.noOrder = true
    }

    const response = await this.paymentService.getEntities(this.pointId)
    console.log('response', response)
    if (!response.value.error) {
      console.log('Success!')
      this.configuration = response.value.data.configuration
      this.nomenclatures = response.value.data.nomenclatures
    }
  },
  mounted () {
    this.guid = guid()
  },
  methods: {
    onResizeWindow () {
      const windowSize = { x: window.innerWidth, y: window.innerHeight }
      this.footerFixed = windowSize.y > windowSize.x
    },
    onShowDialog () {
      this.dialogVisible = true
    },
    async onStart () {
      let response = null
      this.loading = true
      // setTimeout(() => (this.loading = false), 5000)
      if (this.order.state === OrderStateEnum.New) {
        response = await this.justpayQrPaymentService.createBankOrder(this.guid, this.pointId)
      }
      if (this.order.state === OrderStateEnum.Processed) {
        response = await this.justpayQrPaymentService.reGetBankOrder(this.pointId)
      }
      if (!response) return
      this.orderId = response.order
      this.sbpId = response.sbp
      this.nspkLink = response.qr
      // console.log(`orderId=${this.orderId}, sbpId=${this.sbpId}, this.nspkLink=${this.nspkLink}`)
      if (!isBlank(this.orderId) && !isBlank(this.sbpId) && !isBlank(this.nspkLink)) {
        this.noOrder = false
        if (this.order.state === OrderStateEnum.New) {
          await this.justpayQrPaymentService.checkBankState(this.orderId, this.sbpId, this.pointId)
        }
        window.open(this.nspkLink, '_self')
      } else {
        this.noOrder = true
        if (this.orderId) { await this.justpayQrPaymentService.setCancelState(this.orderId, this.sbpId, this.pointId) }
      }
      this.loading = false
    }
  }
}
</script>
<style scoped>
#payment-button {
  background-color: #77cad3;
  border-radius: 12px;
  height: 64px;
  width: 311px;
  //font-family: "Montserrat";
  font-weight: 600;
  font-size: 21px;
  align-content: center;
}
.payment-details {
  color: rgba(56,56,56,0.85);
  font-size: 1.5rem;
}
.payment-no-order {
  color: red;
  font-size: 1.5rem;
  font-weight: 400;
}
.payment-pay {
  background-color: #272155;
  color: white;
  height: 50px;
  border-radius: 12px;
  font-size: 1.5rem;
  font-weight: 600;
}
.payment-pay-disabled {
  background-color: #62626d;
  color: rgba(152,152,152,0.87);
  height: 50px;
  border-radius: 12px;
  font-size: 1.5rem;
  font-weight: 600;
}
.payment-text-center {
  text-align: center;
}
.payment-text-end {
  text-align: end;
}
.payment-text {
  color: #9e9b98;
font-size: 1rem;
  font-weight: 500;
}
.payment-text2 {
  font-size: 28px;
  font-weight: 700;
}
.payment-text3 {
  color: #000000;
  font-size: 1.1rem;
  font-weight: 600;
}
.payment-text4 {
  color: #9e9b98;
  font-size: 1.1rem;
  font-weight: 500;
}
.dialog-input {
  font-size: 14px
}
.dialog-input-sum {
  font-size: 16px;
  font-weight: bold;
}
</style>
